import {
  privatePostApi,
  privateGetApi,
  privatePutApi,
  privateDeleteApi,
} from "../../utils/apiHelper";
import {
  sequences,
  currentSequence,
  enrollments,
  report,
  contactEnrollments,
} from "../slices/sequencesSlice";

export const listSequences = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    privateGetApi("/sequences", payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sequences(response.data.result));
          resolve(response.data.result);
        } else {
          reject(response.message);
        }
      })
      .catch(reject);
  });
};

export const readSequence = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    privateGetApi("/sequences/" + id, {})
      .then((response) => {
        if (response.status === 200) {
          dispatch(currentSequence(response.data.result));
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const createSequence = (payload) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/sequences", payload)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const updateSequence = (payload, id) => () => {
  return new Promise((resolve, reject) => {
    privatePutApi("/sequences/" + id, payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const deleteSequence = (id) => () => {
  return new Promise((resolve, reject) => {
    privateDeleteApi("/sequences/" + id)
      .then((response) => {
        if (response.status === 200) {
          resolve();
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const activateSequence = (id) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/sequences/" + id + "/activate", {})
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const pauseSequence = (id) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/sequences/" + id + "/pause", {})
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const listSequenceEnrollments = (id, payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    privateGetApi("/sequences/" + id + "/enrollments", payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(enrollments(response.data.result));
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const enrollContacts = (id, payload) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/sequences/" + id + "/enroll", payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const exitEnrollment = (sequenceId, contactId) => () => {
  return new Promise((resolve, reject) => {
    privateDeleteApi(
      "/sequences/" + sequenceId + "/enrollments/" + contactId,
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const fetchSequenceReport = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    privateGetApi("/sequences/" + id + "/report", {})
      .then((response) => {
        if (response.status === 200) {
          dispatch(report(response.data.result));
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const listContactEnrollments = (contactId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    privateGetApi("/contacts/" + contactId + "/enrollments", {})
      .then((response) => {
        if (response.status === 200) {
          dispatch(contactEnrollments(response.data.result));
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};
